export const INITIALIZE_SCENE = 'INITIALIZE_SCENE';
export const CLEAR_SCENE = 'CLEAR_SCENE';

export function initializeScene(){
    return {
        type: INITIALIZE_SCENE
    };
}

export function clearScene(){
    return {
        type: CLEAR_SCENE
    };
}
